export class Response<Entity> {
  content: Entity[];

  totalElements: number;

  isFirst: boolean;

  isLast: boolean;
}
